import { Controller } from "@hotwired/stimulus"

// The Tidy-up card: "select all" plus a live "Archive N selected" count.
export default class extends Controller {
    static targets = ["all", "item", "count", "submit"]

    connect() {
        this.update()
    }

    toggleAll() {
        const checked = this.hasAllTarget ? this.allTarget.checked : true
        this.itemTargets.forEach((box) => { box.checked = checked })
        this.update()
    }

    update() {
        const selected = this.itemTargets.filter((box) => box.checked).length
        const total = this.itemTargets.length

        if (this.hasCountTarget) {
            this.countTarget.textContent = selected > 0 ? `Archive ${selected} selected` : "Nothing selected"
        }
        if (this.hasSubmitTarget) {
            this.submitTarget.disabled = selected === 0
        }
        if (this.hasAllTarget) {
            this.allTarget.checked = selected === total && total > 0
            this.allTarget.indeterminate = selected > 0 && selected < total
        }
    }
}
